/**
 * set_initial_data.js - объединяет следующие файлы: set-languages.js, do-repeat-function.js, cookie-functions.js
 * Здесь определяются функции и глобальные переменные, использующиеся в других скриптах.
 * - langSetts - определение конрневого домена и списка языков, которые реализованны на корневых доменах домене.
 * - doRepeat() - функция, выполняющая многократное повторение действий.
 * - cookie-functions - функции для работы с куками.
 **/

/* set-languages -- begin */
var langSetts = {};

langSetts.domainToLanguage = {
    "de": ["de", "en"],
    "com": ["en", "de"],
    "ru": ["ru", "en"],
    "es": ["es", "en"],
    "nl": ["nl", "en"],
    "be": ["fr", "nl", "en"],
    "it": ["it", "en"],
    "se": ["sv", "en"],
    "fr": ["fr", "en"],
    "lu": ["fr", "de", "en"],
    "dk": ["da", "en"],
    "fi": ["fi", "en"],
    "ie": ["en"],
    "at": ["fr", "nl", "en"] // for testing only
};

langSetts.flagsImg = {
    "en": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_gb.gif?v=29240833709549092121658487187",
    "de": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_de.gif?v=153817363893683584411658487247",
    "ru": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_ru.gif?v=157425797126581765811658487175",
    "es": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_es.gif?v=112409603349469841141658487179",
    "nl": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_nl.gif?v=72996060514280769021658487168",
    "fr": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_fr.gif?v=118503650741525333981658487183",
    "it": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_it.gif?v=105411210833734537701658487195",
    "sv": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_se.gif?v=122961284433828329491658487207",
    "da": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_dk.gif?v=89138730171352165451658487231",
    "fi": "//www.attiluscaviar.it/cdn/shop/t/2/assets/flag_fi.gif?v=150502635866458503561658487167"
};

langSetts.domain = window.location.hostname.split('.').pop().toLowerCase();

langSetts.domainLangs = langSetts.domainToLanguage[langSetts.domain];
/* set-languages -- end */



/* do-repeat-function -- begin */
function doRepeat(time1, time2, callback) {
    var timerIdInner = null;
    var timerId = setTimeout(function run() {
        var res = callback();
        if (res === -1) {
            clearTimeout(timerIdInner);
            clearTimeout(timerId);
        } else {
            timerIdInner = setTimeout(run, time1);
        }
    }, 0);

    setTimeout(function() {
        clearTimeout(timerIdInner);
        clearTimeout(timerId);
    }, time2);
}
/* do-repeat-function -- end */



/* cookie-functions -- begin */
/**
 * Возвращает cookie с именем name, если есть, если нет, то undefined
 * @param name - название cookie
 * @returns {any} - возвращает значение cookie, если есть; если нет, то undefined
 */
function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

/**
 * Устанавливает cookie
 * @param name - название cookie
 * @param value - значение cookie (строка)
 * @param options - объект с дополнительными свойствами для установки cookie:
 * expires - время истечения cookie. Интерпретируется по-разному, в зависимости от типа:
 *         Число – количество секунд до истечения. Например, expires: 3600 – кука на час.
 *         Объект типа Date – дата истечения.
 *         Если expires в прошлом, то cookie будет удалено.
 *         Если expires отсутствует или 0, то cookie будет установлено как сессионное и исчезнет при закрытии браузера.
 * path - путь для cookie.
 * domain - домен для cookie.
 * secure - если true, то пересылать cookie только по защищенному соединению.
 */
function setCookie(name, value, options) {
    options = options || {};

    var expires = options.expires;

    if (typeof expires == "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    // #2594 Добавление кук на домены и поддомены
    var domain = options.domain;
    if (typeof domain == "undefined" || !domain){
        var domain_match = window.location.hostname.toLowerCase().match(/[^.]+\.[^.]+$/i);
        domain = domain_match ? domain_match[0] : null;
        options.domain = '.' + domain;
    }
    //

    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }

    document.cookie = updatedCookie;
}

/**
 * Удаляет cookie
 * @param name
 */
function deleteCookie(name, options) {
    options.expires = -1;
    setCookie(name, "", options)
}
/* cookie-functions -- end */



/**
 * encodeHTML -- begin
 * Escaping arguments, especially XML/HTML tags and special characters (angle brackets and slashes).
 */
if (!String.prototype.encodeHTML) {
    String.prototype.encodeHTML = function () {
        return this.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&apos;');
    };
}

if (!String.prototype.decodeHTML) {
    String.prototype.decodeHTML = function () {
        return this.replace(/&apos;/g, "'")
            .replace(/&quot;/g, '"')
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<')
            .replace(/&amp;/g, '&');
    };
}
/* encodeHTML -- end */